import { render, staticRenderFns } from "./post-manage.vue?vue&type=template&id=4461201d&scoped=true"
import script from "./post-manage.vue?vue&type=script&lang=js"
export * from "./post-manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4461201d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4461201d')) {
      api.createRecord('4461201d', component.options)
    } else {
      api.reload('4461201d', component.options)
    }
    module.hot.accept("./post-manage.vue?vue&type=template&id=4461201d&scoped=true", function () {
      api.rerender('4461201d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/post/post-manage.vue"
export default component.exports